/**
 * Red asterisk for presence-validated form fields.
 * Pair with HTML5 `required` on the input — same convention as Rails `required_asterisk`.
 */
import { h } from 'preact'

export function RequiredAsterisk({ id, title, style, className = '' }) {
  const classes = ['text-danger', className].filter(Boolean).join(' ')
  return (
    <span class={classes} aria-hidden="true" id={id} title={title} style={style}>
      *
    </span>
  )
}

export default RequiredAsterisk
